import posts from './postReducer';

import {combineReducers} from 'redux';

const rootReducer = combineReducers({
    posts: posts
});
export default rootReducer;

